import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { EVENT_FORGOT_PASSWORD_SUCCESS, EVENT_FORGOT_PASSWORD_FAIL } from 'js/hooks/usePublicAPI/hooks/useEventsAPI/hooks/useOnForgotPassword';

export const useOnForgotPassword = (eventTarget: EventTarget) => {
    const eventNameSuccess = 'forgotPassword:success';
    const eventNameFail = 'forgotPassword:fail';

    const handleEvent = useCallback((eventName: string, args: unknown[]): void => {
        const event = eventName === eventNameSuccess
            ? new CustomEvent(EVENT_FORGOT_PASSWORD_SUCCESS, { detail: args })
            : new CustomEvent(EVENT_FORGOT_PASSWORD_FAIL, { detail: args });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(eventNameSuccess, (args: unknown[]) => handleEvent(eventNameSuccess, args));
        publicEventsAPIService.on(eventNameFail, (args: unknown[]) => handleEvent(eventNameFail, args));

        return () => {
            publicEventsAPIService.off(eventNameSuccess, handleEvent);
            publicEventsAPIService.off(eventNameFail, handleEvent);
        };
    }, [handleEvent]);
};
